module.exports = __webpack_public_path__ + "img/@tmp_course_thumbnail_06.fea044ce.jpg";